<div
  class="carousel-flat"
  [ngClass]="{
    'carousel-flat--first': isFirstPage,
    'carousel-flat--last': isLastPage
  }"
>
  <div class="carousel-flat__top-line">
    <h3>{{ heading }}</h3>

    <div role="tablist" class="carousel-indicators" *ngIf="showIndicators">
      <button
        *ngFor="let set of slideSets; let i = index"
        role="tab"
        data-bs-target
        [class.active]="currentSlide === i"
        [attr.aria-labelledby]="'slide-ngb-slide-' + i"
        [attr.labelledby]="'slide-ngb-slide-' + i"
        [attr.aria-controls]="'slide-ngb-slide-' + i"
        [attr.selected]="currentSlide === i"
        (click)="slideTo(i)"
      ></button>
    </div>

    <div class="carousel-flat__pagination">
      <ng-container *ngIf="showPagination">
        <button (click)="prev()"
                type="button"
                [attr.title]="isFirstPage ? undefined : ('carousel-controls-previous' | t)"
                class="carousel-control-prev">

          <span aria-hidden="true" class="carousel-control-prev-icon"></span>
          <span class="visually-hidden">{{ 'carousel-controls-previous' | t }}</span>
        </button>
        <div class="carousel-flat__items_count text-small">
          {{ currentSlide + 1 }} of {{ slideSets.length }}
        </div>
        <button (click)="next()"
                type="button"
                [attr.title]="isLastPage ? undefined : ('carousel-controls-next' | t)"
                class="carousel-control-next">

          <span aria-hidden="true" class="carousel-control-next-icon"></span>
          <span class="visually-hidden">{{ 'carousel-controls-next' | t }}</span>
        </button>
      </ng-container>

      <a
        *ngIf="link"
        class="carousel-flat__link text-small ml-2"
        [routerLink]="link"
        [title]="viewAllTitleAttr"
      >
        {{ 'carousel-controls-view-all' | t }}
      </a>
    </div>
  </div>

  <div class="slider-container" #carousel>
    <div
      class="slide d-flex justify-content-between mt-2"
      *ngFor="let slide of slideSets"
    >
      <div
        *ngFor="let item of slide; let i = index"
        [ngClass]="{ 'mr-3': i < slide.length - 1 }"
        class="carousel-flat__item-wrap"
      >
        <ng-template
          [ngTemplateOutlet]="itemTemplate"
          [ngTemplateOutletContext]="{ item: item, index: i }"
        ></ng-template>
      </div>
    </div>
  </div>
</div>
